import { useMemo } from 'react';
import { useOpenTabs } from 'hooks/useOpenTabs';
import { useViewerId } from 'hooks/useViewerId';
import { PageTypes } from 'utils/pageTypes';

type UseViewerMetadata = {
  numberOfViewerWindows: number;
  windowId: Nullable<string>;
  openWindowsIds: ReadonlyArray<string>;
};

export const useViewerMetadata = (): UseViewerMetadata => {
  const windowId = useViewerId();
  const { tabs, openedViewerIds } = useOpenTabs();
  const numberOfViewerWindows = tabs.filter((tab) => tab.type === PageTypes.VIEWER).length;
  const openWindowsIds: Array<string> = useMemo(
    () => Array.from(openedViewerIds),
    [openedViewerIds]
  );

  return { numberOfViewerWindows, windowId, openWindowsIds };
};
